
const {ccclass, property} = cc._decorator;

@ccclass
export default class TaskShareIntroduce extends cc.Component {

    @property(cc.PageView)
    pageV: cc.PageView = null;
    @property(cc.Node)
    page: cc.Node = null;
    @property(cc.Node)
    content: cc.Node = null;

    start () {

    }
    updateUI(titleImg){

        if (this.content.children.length > 0) return;
        for (let i = 0;i < titleImg.length;i++){
            let page = cc.instantiate(this.page);
            page.active = true;
            this.pageV.addPage(page);
            this.pageV.setCurrentPageIndex(i);
        }
        this.pageV.scrollToPage(0,0.1);
        for (let i = 0;i < titleImg.length;i++){
            let page = this.content.children[i];
            cc.loader.load(titleImg[i], function (err, texture) {
                if (!err && this.node) {
                    if (cc.isValid(page)) {
                        page.getChildByName("logo").active = false;
                        page.getComponent(cc.Sprite).spriteFrame = new cc.SpriteFrame(texture);
                    }
                } else {
                    cc.log("===加载图片spAgent错误");
                }
            }.bind(this))
        }
    }

    onBtnIKnow(){
        this.node.active = false;
    }

    onBtnLeft(){
        let index = this.pageV.getCurrentPageIndex() - 1;
        cc.log("====index:",index);
        index = index < 0 ? 0 : index;
        this.pageV.scrollToPage(index,0.3);
    }

    onBtnRight(){
        let index = this.pageV.getCurrentPageIndex() + 1;
        if (index > this.pageV.getPages().length - 1 ){
            index = this.pageV.getPages().length - 1;
        }
        this.pageV.scrollToPage(index,0.3);
    }
}
